import { HTMLAttributes } from 'react';

import { lighten, styled } from '@material-ui/core';

export type ChartGraphicProps = HTMLAttributes<SVGElement> & {};

const ThemeBackgroundSvg = styled('svg')(({ theme }) => ({
  background:
    theme.palette.type === 'dark'
      ? theme.palette.background.default
      : 'rgb(242,242,242)',
}));

const ThemeFillPath = styled('path')(({ theme }) => ({
  fill:
    theme.palette.type === 'dark'
      ? lighten(theme.palette.background.default, 0.06)
      : 'rgb(247,247,247)',
}));

export const ChartGraphic = (props: ChartGraphicProps) => {
  return (
    <ThemeBackgroundSvg
      viewBox="0 0 1728 1117"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      {...props}
    >
      <ThemeFillPath d="M864.5 -63C424.682 -63 358.78 1160 -265 1160H1994C1461.85 1160 1304.32 -63 864.5 -63Z" />
    </ThemeBackgroundSvg>
  );
};
